<template>
  <div>
    <header>
      <nav class="navbar navbar-nelsoni ">
        <div class="navbar-brand">
          <router-link class="navbar-item " :class="path('#/')" to="/">
            <span class="icon-logoNelsoniRanch_blanco"></span>
          </router-link>
          <div class="navbar-burger burger" data-target="menu">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div id="menu" class="navbar-menu">
          <div class="navbar-end">
            <router-link class="navbar-item " :class="path(['/productos','/bedding-and-litter-camas', '/natural-hay-pasturas', '/natural-mix-aves', '/natural-mix-roedores', '/complete-food', '/suplementos']) " to="/productos">Productos</router-link>
            <router-link class="navbar-item " :class="path('/nosotros')" to="nosotros">Nosotros</router-link>
            <router-link class="navbar-item " :class="path('/contacto')" to="contacto">Contacto</router-link>

            <div class="navbar-item social-item">
              <a href="https://www.facebook.com/NelsoniRanch" target="_blank">
                <span class="icon">
                  <i class="fa fa-facebook-official" aria-hidden="true"></i>
                </span>
              </a>
              <a href="https://www.instagram.com/nelsoniranch " target="_blank">
                <span class="icon">
                  <i class="fa fa-instagram" aria-hidden="true"></i>
                </span>
              </a>
              <a href="https://www.youtube.com/" target="_blank">
                <span class="icon">
                  <i class="fa fa-youtube-play" aria-hidden="true"></i>
                </span>
              </a>
            </div>
          </div>

        </div>
      </nav>
    </header>

  </div>
</template>
<script>

export default {
  name: 'header',
  methods: {
    path(pathName) {
      if (typeof pathName != "string") {
        let className = null;
        pathName.forEach((item, i) => {
          if (window.location.pathname === item) {
            className = 'active';
          }
        });
        return className;
      }
      return window.location.pathname === pathName ? 'active' : null
    }
  },
  mounted() {
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0)
    if ($navbarBurgers.length > 0) {
      $navbarBurgers.forEach(($el) => {
        $el.addEventListener('click', () => {
          const target = $el.dataset.target
          const $target = document.getElementById(target)
          $el.classList.toggle('is-active')
          $target.classList.toggle('is-active')
        })
      })
    }
  }
}
</script>
<style lang="scss">
$green:#7cb542;
header {
  .icon-logoNelsoniRanch_blanco:before {
    content: "\e900";
    color: #fff;
    font-size: 4em;
  }
  >.navbar-nelsoni {
    background: $green;
    height: 100px;
    margin: auto;
    z-index: 9999;
    .navbar-brand {
      .navbar-item {

        &:hover {
          background: transparent !important;
        }

        .logo {
          max-height: 5em;
        }
      }
      .navbar-burger {
        width: 100px;
        height: 100px;
        color: white;
        &.burger {
          margin-top: auto;
          margin-bottom: auto;
        }
        span {
          font-size: 2em;
        }
      }
    }
    .navbar-menu {
      &.is-active {
        .navbar-end {
          a {
            color: black;
          }
          .social-item {

            a {
              &:hover {
                color: $green;
              }
            }
          }
        }
      }
      .navbar-end {
        padding: 10px;
        &.active {
          a {
            color: black;
            text-decoration: underline;
          }
        }
        a {
          &.active {
            color: black;
            text-decoration: underline;
          }
          background: transparent;
          color: white;
          text-transform: uppercase;
          font-weight: 400;
          font-family: 'Montserrat',
          sans-serif;
          font-size: .9em;
          &:hover {
            color: black;
            text-decoration: underline;
          }
        }
        .social-item {
          font-size: 2em;
          a {
            &:hover {
              text-decoration: none;
            }
            span {
              margin: 10px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue